import React from 'react';
import { Page, Document, Image, StyleSheet, View, Text } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle'
import BillTo from './BillTo'
import InvoiceTableHeader from'./InvoiceTableHeader'
import InvoiceNo from './InvoiceNo'
import InvoiceItemsTable from './InvoiceItemsTable'
import InvoiceThankYouMsg from './InvoiceThankYouMsg'
import logo from '../mpl-logo.png'



const styles = StyleSheet.create({
    page: { 
        paddingTop:190,
        paddingBottom:200,
        fontSize: 8,
        lineHeight: 1.5,
        flexDirection: 'column'
    },
    box: { width: '100%', marginBottom: 30, borderRadius: 5 },
    pageNumbers: {
      position: 'absolute',
      bottom: 20,
      left: 0,
      right: 0,
      textAlign: 'center'
    },
    
    logo: {
        width: 180,
        height: 100
    },
    barcode: {
        width: 150,
        height: 40
    },
    titleContainer:{
      width:"100%"
  },
  reportTitle:{
      color: 'black',
      fontSize: 12,
      width:"15em",
      marginLeft:-55,
      fontFamily:'Helvetica-Bold',
      textAlign: 'center',
      textTransform: 'uppercase',
      textDecoration:'underline'
  }
  });
  const date=new Date()
  Date.prototype.ddmmyyy = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        this.getFullYear()
    ].join('/');
};
var time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
  const Invoice=({invoice})=> (
    <Document>
      <Page style={styles.page} size="A4" wrap={true} >
      <View fixed style={{
                width: '100%', 
                display: 'flex',
                 flexDirection: 'row', 
                 top: 0, 
                 position: 'absolute',
                paddingLeft: 10,
                alignItems:"center",
                paddingRight: 10,
                paddingTop: 10
            }} >
               <View style={{display: 'flex', flexDirection: 'column' , marginLeft:10}}>
                  <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7
                    }}>Date</Text>
                  <Text style={{fontFamily:'Helvetica', color:'grey'}}>{date.ddmmyyy()}</Text>
                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>Time</Text>
                  <Text style={{fontFamily:'Helvetica', color:'grey'}}>{time}</Text>
                  <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7
                    }}>From</Text>
                  <Text style={{fontFamily:'Helvetica', color:'grey'}}>{localStorage.getItem("branch_name")}</Text>
                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>To</Text>
                  <Text style={{fontFamily:'Helvetica', color:'grey'}}>{"MPL-Islamabad G-8"}</Text>
                </View>
                <View style={{
                  flex:'0.5',
                  flexDirection:'column',
        marginLeft:120
                }}>
                <Image style={styles.logo} src={logo} />
                <View style={styles.titleContainer}>
  {/* 10-july-2024 */}

        {/* <Text style={styles.reportTitle}>Collection Point Samples Dispatch Log Sheet</Text> */}
        <Text style={styles.reportTitle}> BOOKING LOG SHEET</Text>

       
       
    </View>
    </View>
    <View style={{display: 'flex', flexDirection: 'column' ,marginLeft:260}}>
                  <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7,
                    padding:5,
                    borderWidth:0.5
                    
                    }}>MPL-GEN-F033</Text>
                <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7,
                    padding:5,
                    borderWidth:0.5
                    }}>Issue No # 1</Text>
                <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7,
                    padding:5,
                    borderWidth:0.5

                    }}>Issue Date : 01.03.2022</Text>
                
                </View>
 <View style={{
  display:'flex',
  position:'absolute',
  width:'100%',
  marginLeft:10,
  paddingTop:202
 }}>
  {/* 10-july-2024 */}
    <View style={{
      padding:"2em",
      fontSize:10
    }}>
      <Text style={{color:"white"}}>Dear Sir</Text>
     <Text style={{color:"white"}}> Please find enclosed sample (S) for the following lab test (S)</Text>
     </View>
     <InvoiceTableHeader />
   </View>
            
               
            </View>

            <View style={{width:'100%',paddingRight:10, paddingLeft:10}} 
           
           >
             
               <InvoiceItemsTable 
               
              
               
               invoice={invoice} />
           </View>

         {/* <View fixed style={{ position: 'absolute', width: '100%', bottom: 0}}>
            <View style={{
              paddingLeft:30,
              paddingRight:30,
              paddingBottom:20,
              lineHeight:4,
              display:"flex",
              flexDirection:"column"
            }}>
                  <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7
                    }}>For Collection Point Only</Text>
                 
                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>Dispatched by: __________________________________________________     Date & Time _________________________________________</Text>
                  <Text style={{ 
                    fontFamily:'Helvetica-Bold',
                    fontSize:7
                    }}>For MPL Lab Use Only</Text>
                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>Received by: ____________________________________________________     Date & Time _________________________________________</Text>

                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>Temperature upon receiving: _______________________________________________________________________________________________</Text>

                  <Text style={{fontFamily:'Helvetica-Bold', fontSize:7}}>Acceptable (   )  Unacceptable (   )</Text>
                 
           </View>
           </View> */}
        
      </Page>
    </Document>
  );
  
export default Invoice